@if (!statesService.ringing) {
  <div class="dog">
    <div class="head"
      [class.normal]="statesService.createViewClasses() === 'normal'"
      [class.tired]="statesService.createViewClasses() === 'tired'"
      [class.hungry-thirsty]="statesService.createViewClasses() === 'hungry-thirsty'"
      [class.sad]="statesService.createViewClasses() === 'sad'"
      [class.exited]="statesService.states.showGames || statesService.states.showFoods"
      [class.exited-tongue]="statesService.states.showFoods"
      [class.sleeping]="simulation.pet.sleeping"
      >
      <div class="ear-left"></div>
      <div class="ear-right"></div>
    </div>
    <div class="buddy-koerper"></div>
    <div class="tail"
      [class.waggle-exited]="statesService.states.showGames || statesService.states.showFoods"
      [class.dropped]="simulation.pet.sleeping"
      >
    </div>
  </div>
}

@if (statesService.ringing) {
  <app-clock></app-clock>
}

@if (simulation.pet.droppedPee > 0 && statesService.ringing === false) {
  <div class="pee"
    [style.transform]="'scale('+ (0.8 + 0.2 * simulation.pet.droppedPee) + ')'"
    >
  </div>
}

@if (simulation.pet.droppedPoo > 0 && statesService.ringing === false) {
  <div class="flies fly1"></div>
}
@if (simulation.pet.droppedPoo > 0 && statesService.ringing === false) {
  <div class="flies fly2"></div>
}
@if (simulation.pet.droppedPoo > 0 && statesService.ringing === false) {
  <div class="flies fly3"></div>
}

@if (simulation.pet.droppedPoo > 0 && statesService.ringing === false) {
  <div class="poo"
    [style.transform]="'scale('+ (0.8 + 0.2 * simulation.pet.droppedPoo) + ')'"
    >
  </div>
}

